import React from 'react';
import './index.less';
export default function SellingPoint({ labels }: { labels: TitleType.Root['labels'] }) {
  //卖点local stock
  if (labels.length == 0) return null;
  return (
    <>
      {labels.map((i: string) => (
        <span key={i} className="selling-point detail-separator">
          {i}
        </span>
      ))}
    </>
  );
}
